import React from 'react';
import Card from '@material-ui/core/Card';
import Divider from '@material-ui/core/Divider';

/**
 * This function renders the InvestorRelations page
 * @component InvestorRelations
 * @return {Component} InvestorRelations component
 */
export default function InvestorRelations() {
  return (
    <div>
      <Card
        style={{
          padding: '50px',
          width: '1200px',
          margin: '30px auto 30px auto',
        }}
      >
        <h1>Investor Relations</h1>
        <Divider />
        <div style={{fontSize: '18px', lineHeight: '1.5'}}>
          <br />
          <p>
            The Advanced Intelligence Services Corporation seeks funding for
            it's 2022-24 operating schedule. This term
            offers opportunities for partners to engage in accelerated
            information research and development programs designed for
            multi-circa interactivity in, and beyond the twenty-first century.
          </p>
          <p>For more information about investor relations, please contact: </p>
          <p>
            Jim D. Ray, C.E.O.
            <br />
            Advanced Intelligence Services Incorporated
            <br />
            1-800-427-9479 Toll-Free
            <br />
            invest@aisincorporated.com
          </p>
        </div>
        <br />
      </Card>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </div>
  );
}
